/** @jsxImportSource @emotion/react */

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PageTemplate from '@page/iyagigo/page-template';
import * as color from '@constant/color';
import StudioHome from '@component/iyagigo/studio/studio-home';
import Scroll from '@component/common/scroll';

const StudioHomePage: React.FC<any> = () => {
  // ############### route ###############
  const location = useLocation();

  // ############### state ###############

  // ############### variable ###############
  const HEADER_TITLE = '학습관리';

  return (
    <PageTemplate title={HEADER_TITLE} mode={'page'} backgroundColor={color.GRAY_BACKGROUND_COLOR}>
      <Scroll direction='y' height={`calc(100% - 10px)`}>
        <StudioHome />
      </Scroll>
    </PageTemplate>
  );
};

export default StudioHomePage;
